module.exports = __webpack_public_path__ + "static/media/material.49882e91.svg";